module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture33-2fc8d0f345c81f72d46f06e39f28ab26.jpg";